<template>
  <div class="page">
    <PageHeader
      :to="{ name: 'member-show' }"
    ><div slot="middle">History</div></PageHeader>
    <div class="d-flex justify-center pb-10">
      <VTimeline
        style="max-width:1000px;"
        class="w-100"
        dense
      >
        <div v-for="day in activityLog" :key="day.date">
          <VTimelineItem
            class="mb-6"
            hide-dot
          >
            <span class="grey--text font-weight-bold">{{ day.date }}</span>
          </VTimelineItem>
          <VTimelineItem
            v-for="event in day.events"
            :key="event.time"
            class="mb-4"
            color="primary"
            small
          >
            <div class="d-flex justify-space-between align-center">
              <VCard
                class="pa-4"
                style="max-width: 600px;"
              >{{ event.text }}</VCard>
              <div class="col separator-line"></div>
              <div>{{ event.time }}</div>
            </div>
          </VTimelineItem>
        </div>
      </VTimeline>
    </div>
  </div>
</template>

<script>

import PageHeader from '@/globals/components/PageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  computed: {
    activityLog() {
      return [
        {
          date: '22. October 2020',
          events: [
            {
              time: '07:32',
              text: 'You logged in',
            },
            {
              time: '08:40',
              text: 'You added Lise Mortensen to your citizens',
            },
            {
              time: '08:52',
              text: 'You removed Mogens Sørensen from your citizens',
            },
            {
              time: '09:12',
              text: 'You added 2 tasks to Lise Mortensen',
            },
            {
              time: '11:57',
              text: 'You approved 6 deviations for Alfred Hansen',
            },
            {
              time: '12:03',
              text: 'You logged out',
            },
          ],
        },
        {
          date: '23. October 2020',
          events: [
            {
              time: '10:46',
              text: 'You logged in',
            },
            {
              time: '12:41',
              text: 'You approved 4 deviations for Lise Mortensen',
            },
            {
              time: '12:57',
              text: 'You added 9 citizens to your citizens',
            },
            {
              time: '14:20',
              text: 'You created 16 tasks for 9 citizens',
            },
            {
              time: '15:18',
              text: 'You logged out',
            },
          ],
        },
      ];
    },
  },
};

</script>

<style scoped lang="scss">
  .separator-line {
    height: 1px;
    padding: 0px;
    margin: 0 12px;
    background-color: lightgrey;
    min-width: 50px;
  }
</style>
